+function($, window, document) {
	//init ajax notification
	$('.sn-processing-bar').AjaxNotification({
		useProcessBar: true
	});
	
	$(function($) {
		//init popupcart
		$('#cart-menu').PopupCart();
		
		//facebook logout
		$('#user-menu').on('click', 'a.logout', function(event) {
			$.publish('showajaxnotification.sn', 'PROCESSING..');
			
			event.preventDefault();
			
			window.location = $(this).attr('href');
			
			return false;
		}); 
		
		setTimeout(function() {
			$(document.body).removeClass('sn-desktop-processing');
		}, 900);
	}); 
}(jQuery, window, document);